import Chip from "@mui/material/Chip";
import { CustomCellDate, CrudLink } from "@/shared/components";
import type { ColumnDefinition } from "@/shared/components/CRUD/types";
import type { MigrationRow } from "./types";
import type { DataListViewColumns } from "@/shared/components/DataListView";
import { Stack, Typography } from "@mui/material";

const getStatusColor = (status?: string | null) => {
  switch (status) {
    case "succeeded":
      return "success";
    case "failed":
      return "error";
    case "processing":
      return "warning";
    default:
      return "default";
  }
};

const getStatusLabel = (status?: string | null) => {
  switch (status) {
    case "succeeded":
      return "Выполнена";
    case "failed":
      return "Ошибка";
    case "processing":
      return "Выполняется";
    default:
      return "Не запущена";
  }
};

export const getColumnsConfig = (): ColumnDefinition<MigrationRow>[] => [
  { name: "id", label: "ID", options: { display: false, filter: false } },
  {
    name: "title",
    label: "Название",
    options: {
      customBodyRender: (value: unknown) => {
        const [title, id] = value as [string, string];
        return (
          <CrudLink id={id} tab="details">
            {title}
          </CrudLink>
        );
      },
    },
  },
  {
    name: "status",
    label: "Статус",
    options: {
      customBodyRender: (value: unknown) => (
        <Chip
          label={getStatusLabel(value as string)}
          color={getStatusColor(value as string)}
          size="small"
          variant="outlined"
        />
      ),
    },
  },
  {
    name: "attempts",
    label: "Попытки",
    options: {
      setCellHeaderProps: () => ({ style: { width: 100 } }),
    },
  },
  {
    name: "createdAt",
    label: "Создана",
    options: {
      setCellHeaderProps: () => ({ style: { width: 150 } }),
      customBodyRender: (value: unknown) => (
        <CustomCellDate date={value as string} />
      ),
    },
  },
  {
    name: "lastRunAt",
    label: "Последний запуск",
    options: {
      setCellHeaderProps: () => ({ style: { width: 150 } }),
      customBodyRender: (value: unknown) => {
        const dateValue = value as string | null;
        return dateValue ? <CustomCellDate date={dateValue} /> : "—";
      },
    },
  },
];

export const getTextsConfig = () => ({
  filterTitle: "Фильтры",
  listTitle: "Миграции",
  refetchList: "Обновить список",
  showTitle: "Детали",
  editItem: "Миграция",
});

// Колонки для мобильного представления: название с попытками и статус
export const getMobileColumnsConfig =
  (): DataListViewColumns<MigrationRow> => ({
    main: {
      title: "Миграция",
      sx: { flex: 1, minWidth: 0 },
      renderCell: (row) => (
        <Stack sx={{ minWidth: 0 }}>
          <CrudLink id={row.id} tab="details" noWrap>
            {row.title}
          </CrudLink>
          <Typography variant="body2" color="textSecondary" noWrap>
            {row.lastRunAt ? (
              <CustomCellDate date={row.lastRunAt as string} />
            ) : (
              "не запускалась"
            )}
          </Typography>
        </Stack>
      ),
    },
    status: {
      title: "Статус",
      sx: { width: 108, flexShrink: 0 },
      renderCell: (row) => (
        <Chip
          label={getStatusLabel(row.status)}
          color={getStatusColor(row.status)}
          size="small"
          variant="outlined"
        />
      ),
    },
  });
